import {
  getAllContracts,
  getAllServicesRequests,
  rejectContract,
} from '@/sdk/clients/MyCaregiversClient'

export default {
  async getContracts({ commit }) {
    const response = await getAllContracts()
    commit('setContracts', response)
  },

  async getServiceRequests({ commit }) {
    const response = await getAllServicesRequests()
    commit('setServiceRequests', response)
  },

  async rejectContract(_, payload) {
    await rejectContract(payload)
  },
}
